import { Action, createReducer, on } from '@ngrx/store';
import { TsForwardSettingsReducer } from '../ts-forward-settings.model';
import * as tsForwardSettingsActions from './ts-forward-settings.action';

const initialState: TsForwardSettingsReducer = {
  tsForwardSettings: [],
  isLocallyChanged: false,
};

const reducer = createReducer(
  initialState,

  on(tsForwardSettingsActions.setTsForwardSettings, (state, props) => ({
    ...state,
    tsForwardSettings: props.tsForwardSettings,
    isLocallyChanged: false,
  })),

  on(tsForwardSettingsActions.addTsForwardSetting, (state, props) => ({
    ...state,
    tsForwardSettings: [...state.tsForwardSettings, props.tsForwardSetting],
    isLocallyChanged: true,
  })),

  on(tsForwardSettingsActions.updateTsForwardSetting, (state, props) => ({
    ...state,
    tsForwardSettings: state.tsForwardSettings.map((tsForwardSetting) =>
      tsForwardSetting.id === props.tsForwardSetting.id
        ? { ...props.tsForwardSetting }
        : tsForwardSetting
    ),
    isLocallyChanged: true,
  })),

  on(tsForwardSettingsActions.reorderTsForwardSettings, (state, props) => ({
    ...state,
    tsForwardSettings: props.tsForwardSettings,
    isLocallyChanged: true,
  })),

  on(tsForwardSettingsActions.deleteTsForwardSettings, (state, props) => ({
    ...state,
    tsForwardSettings: state.tsForwardSettings.filter(
      (tsForwardSetting) => !props.ids.includes(tsForwardSetting.id)
    ),
    isLocallyChanged: true,
  })),

  on(tsForwardSettingsActions.setTsForwardSettingsLocallyChanged, (state, props) => ({
    ...state,
    isLocallyChanged: props.isLocallyChanged,
  })),

  on(tsForwardSettingsActions.clearTsForwardSettings, () => ({
    ...initialState,
  }))
);

export function tsForwardSettingsReducer(
  state: TsForwardSettingsReducer | undefined,
  action: Action
) {
  return reducer(state, action);
}
